module.exports = __webpack_public_path__ + "static/media/coins-fill.d6700f4f.svg";